var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFHanche1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 178,
    viewBox: "0 0 94 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7551 0.0998535C79.6637 20.1501 74.772 50.4528 77.3287 71.5254C78.7615 83.3352 80.3123 92.139 81.4133 111.295C82.5143 130.451 83.088 148.997 81.3248 177.1",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.822 72.0051C85.822 72.0051 91.0163 96.487 91.0163 136.182",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76123 0.0998535C11.8527 20.1501 16.7444 50.4528 14.1877 71.5254C12.7548 83.3352 11.2041 92.139 10.1031 111.295C9.00209 130.451 8.42839 148.997 10.1916 177.1",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69433 72.0051C5.69433 72.0051 0.500059 96.487 0.500059 136.182",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFHanche1);
export default __webpack_public_path__ + "static/media/F-HANCHE_1.c5f2d7eb9bbfe440450dbe61519f2d6d.svg";
export { ForwardRef as ReactComponent };